import { yupResolver } from "@hookform/resolvers/yup";
import React, { useEffect, useState } from "react";
import { Button, Card, Col, Form, Row } from "react-bootstrap";
import { FormProvider, useForm } from "react-hook-form";
import { useLocation, useNavigate } from "react-router-dom";
import * as yup from "yup";
import BasicInformation from "./BasicInformation";
import { SignUpAPI, EPromotionsAPI } from "api";
import { customSettings, LOCAL_STORAGE_USER } from "utils/customConfig";
import { toast } from "react-toastify";
import PageTitle from "utils/PageTitle";
import BreadCrumbTable from "components/breadcrumb/BreadCrumbTable";

// const schema = yup.object({
//   sellerId: yup.number(),
//   name: yup.string().required("This field is required"),
//   type: yup.string().required("This field is required"),
//   discountValue: yup.string().default("0"),
//   discountType: yup.string().required("This field is required"),
//   startDate: yup.string(),
//   endDate: yup.string(),
//   applicableTo: yup.string(),
//   referenceId: yup.string(),
//   usageLimit: yup.string(),
//   usagePerCustomer: yup.string(),
//   minOrderValue: yup.string(),
//   channel: yup.string(),
//   status: yup.boolean(),
// });
// .required();

const schema = yup.object({
  sellerId: yup.number(),

  name: yup.string().required("This field is required"),

  type: yup.string().required("This field is required"),

  discountType: yup.string().required("This field is required"),

  discountValue: yup.string().when("type", {
    is: "FreeShipping",
    then: (schema) => schema.default("0").notRequired(),
    otherwise: (schema) => schema.required("Discount value is required"),
  }),

  usageLimit: yup.string().when("type", {
    is: "FreeShipping",
    then: (schema) => schema.default("0").notRequired(),
    otherwise: (schema) => schema.required("Usage limit is required"),
  }),

  usagePerCustomer: yup.string().when("type", {
    is: "FreeShipping",
    then: (schema) => schema.default("0").notRequired(),
    otherwise: (schema) => schema.required("Usage per customer is required"),
  }),

  minOrderValue: yup.string().when("type", {
    is: "FreeShipping",
    then: (schema) => schema.default("0").notRequired(),
    otherwise: (schema) => schema.required("Minimum order value is required"),
  }),

  startDate: yup.string().when("type", {
    is: "FreeShipping",
    then: (schema) => schema.default("").notRequired(),
    otherwise: (schema) => schema.required("Start date is required"),
  }),

  endDate: yup.string().when("type", {
    is: "FreeShipping",
    then: (schema) => schema.default("").notRequired(),
    otherwise: (schema) => schema.required("End date is required"),
  }),

  applicableTo: yup.string().default(""),
  referenceId: yup.string().default(""),
  channel: yup.string().default(""),

  status: yup.boolean().default(false),
});

const AddPromotion = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [loading, setLoading] = useState(false);

  const submittedValues = {};
  const methods = useForm({
    resolver: yupResolver(schema),
    defaultValues: {},
  });
  const { handleSubmit, reset, setValue } = methods;

  // const onSubmit = async (data) => {
  //   let myData = {
  //     ...data,
  //     id: location?.state?.id ?? 0, // Use nullish coalescing to handle undefined or null
  //     sellerId: LOCAL_STORAGE_USER?.id
  //   };

  //   // console.log(myData);

  //   try {
  //     if (location?.state) {
  //       setLoading(true);
  //       await EPromotionsAPI.post(myData);
  //       setLoading(false);
  //       toast.success("Promotion Updated Successfully", {
  //         position: customSettings.toastPosition,
  //         autoClose: customSettings.toastClose,
  //       });
  //     } else {
  //       setLoading(true);
  //       await EPromotionsAPI.post(myData);
  //       setLoading(false);
  //       toast.success("Promotion Created Successfully", {
  //         position: customSettings.toastPosition,
  //         autoClose: customSettings.toastClose,
  //       });
  //     }

  //     // ------- Get all object keys form data and set empty values to reset ------------
  //     const keys = Object.keys(data);
  //     for (const key of keys) {
  //       submittedValues[key] = "";
  //     }
  //     reset({ ...submittedValues });
  //     navigate(-1);
  //   } catch (error) {
  //     toast.error("Something Went Wrong", {
  //       position: customSettings.toastPosition,
  //       autoClose: customSettings.toastClose,
  //     });
  //     console.log(error);
  //   }
  // };

  const onSubmit = async (data) => {
    const today = new Date().toISOString().split("T")[0];

    let myData = {
      ...data,
      id: location?.state?.id ?? 0,
      sellerId: LOCAL_STORAGE_USER?.id,
      referenceId: location?.state?.referenceId ?? 0,
    };

    // Only for CREATE + FreeShipping
    if (data.type === "FreeShipping" && !location?.state) {
      const defaultValuesMap = {
        // string/date fields
        startDate: today,
        endDate: today,
        applicableTo: "",
        channel: "",

        // numeric fields
        discountValue: 0,
        usageLimit: 0,
        usagePerCustomer: 0,
        minOrderValue: 0,
      };

      Object.entries(defaultValuesMap).forEach(([key, defaultValue]) => {
        if (
          myData[key] === undefined ||
          myData[key] === null ||
          myData[key] === ""
        ) {
          myData[key] = defaultValue;
        }
      });
    }

    try {
      setLoading(true);
      await EPromotionsAPI.post(myData);

      toast.success(
        location?.state
          ? "Promotion updated successfully"
          : "Promotion created successfully",
        {
          position: customSettings.toastPosition,
          autoClose: customSettings.toastClose,
        },
      );

      reset({});
      navigate(-1);
    } catch (error) {
      toast.error("Something went wrong", {
        position: customSettings.toastPosition,
        autoClose: customSettings.toastClose,
      });
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (location?.state) {
      // Extract data and ensure valid date formatting
      const promotionData = { ...location.state };

      const formatDate = (dateStr) => {
        if (!dateStr) return new Date().toISOString().split("T")[0];
        const d = new Date(dateStr);
        return d.toLocaleDateString("en-CA"); // YYYY-MM-DD
      };

      reset({
        ...promotionData,
        startDate: formatDate(promotionData.startDate),
        endDate: formatDate(promotionData.endDate),
      });
    }
  }, [location?.state, reset]);

  return (
    <>
      <PageTitle name="E Commerce | Promotions" />
      {/* <div className="py-2">
        <BreadCrumb />
      </div> */}
      <FormProvider {...methods}>
        <Form onSubmit={handleSubmit(onSubmit)} noValidate>
          <Card>
            <Card.Header className="border-bottom">
              <Row className="flex-between-center ">
                <Col md>
                  {/* <h5 className="fs-9 text-nowrap mb-2 mb-md-0">
                    {" "}
                    E Commerce | Promotions
                  </h5> */}
                  <BreadCrumbTable
                    title="Promotions"
                    subTitle={location?.state?.name}
                  />
                </Col>
                <Col xs="auto">
                  <Button
                    variant="link"
                    className="text-secondary fw-medium p-0 me-3"
                    type="button"
                    onClick={() => navigate(-1)}
                  >
                    Cancel
                  </Button>
                  <Button variant="primary" type="submit" disabled={loading}>
                    Ok
                  </Button>
                </Col>
              </Row>
            </Card.Header>
            <BasicInformation />
          </Card>
        </Form>
      </FormProvider>
    </>
  );
};

export default AddPromotion;
